var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Alert, Box, Button, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Stack, TextField, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { DateTime } from "luxon";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { MyAccountService } from "../../../services/identity/myAccount.service";
import { ProfileService } from "../../../services/profile/profile.service";
import { useReadOnly } from "../../../utils/hooks/users/useReadOnly";
import { useAllUsers } from "../../../utils/hooks/users/useUsers";
import CommonConfirmDialog from "../../dialog/CommonConfirmDialog";
import CollapsibleSection from "./CollapsibleSection";
var PMS_NAMES = {
    elite: 'Elite',
    casablanca: 'Casablanca',
    protel: 'protel',
    fidelio: 'Fidelio',
    asa: 'ASA',
    ohip: 'Opera',
    mews: 'Mews',
    apaleo: 'apaleo',
    crqlarv2: 'Crqlar',
};
var pmsName = function (provider) { var _a; return provider ? (_a = PMS_NAMES[provider.toLowerCase()]) !== null && _a !== void 0 ? _a : provider : 'Crqlar'; };
var categoryOf = function (name) { return (name === null || name === void 0 ? void 0 : name.replace(/_/g, ' ').trim()) || undefined; };
var isWrittenInCrqlar = function (note) { var _a; return !((_a = note.externalInfo) === null || _a === void 0 ? void 0 : _a.length); };
// Source-less "Reservation Note" entries are Crqlar's copies of booking notes (createInternalNoteBasedOnReservationNote).
var isBookingCopy = function (note) { return note.noteType === 'Reservation Note' && isWrittenInCrqlar(note); };
var hasText = function (note) { var _a; return !!((_a = note.note) === null || _a === void 0 ? void 0 : _a.trim()); };
var timeOf = function (note) { var _a, _b; return new Date((_b = (_a = note.insertDate) !== null && _a !== void 0 ? _a : note.updateDate) !== null && _b !== void 0 ? _b : 0).getTime(); };
// Embedded notes have no id, and the profile can reload while a form is open: find a note again by what it is.
var isSameNote = function (a, b) {
    return a.note === b.note && a.userEmailSource === b.userEmailSource && timeOf(a) === timeOf(b);
};
// The guest's note is found again by its text, as the API finds it.
var isSameRow = function (a, b) {
    var _a;
    return a.crqlarNote && b.crqlarNote
        ? isSameNote(a.crqlarNote, b.crqlarNote)
        : !!a.guestNote && a.guestNote.note === ((_a = b.guestNote) === null || _a === void 0 ? void 0 : _a.note);
};
var GuestNotes = function (_a) {
    var _b;
    var profile = _a.profile, setProfile = _a.setProfile;
    var t = useTranslation().t;
    var readOnly = useReadOnly();
    var queryClient = useQueryClient();
    var _c = useState(''), draft = _c[0], setDraft = _c[1];
    var _d = useState(), editing = _d[0], setEditing = _d[1];
    var _e = useState(), menu = _e[0], setMenu = _e[1];
    var _f = useState(), deleting = _f[0], setDeleting = _f[1];
    // Focus only on an explicit section open, so opening the profile does not steal keyboard focus.
    var _g = useState(false), focusDraft = _g[0], setFocusDraft = _g[1];
    var me = useQuery(['myAccount'], function () { return MyAccountService.getMyAccount(); }).data;
    var users = useAllUsers().data;
    var stayNotes = useQuery(['stayNotes', profile.id], function () { return ProfileService.getStayNotes(profile.id); }, { enabled: !!profile.id, staleTime: 30000 }).data;
    var writerOf = function (email) {
        var _a;
        if (!email)
            return undefined;
        var user = (_a = users === null || users === void 0 ? void 0 : users.find(function (access) { var _a, _b; return ((_b = (_a = access.user) === null || _a === void 0 ? void 0 : _a.email) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === email.toLowerCase(); })) === null || _a === void 0 ? void 0 : _a.user;
        return (user === null || user === void 0 ? void 0 : user.firstName) || email;
    };
    var dayOf = function (date) {
        var day = DateTime.fromJSDate(new Date(date));
        return day.toFormat(day.hasSame(DateTime.local(), 'year') ? 'dd.MM' : 'dd.MM.yyyy');
    };
    var writtenAt = function (note) {
        var _a;
        var date = (_a = note.insertDate) !== null && _a !== void 0 ? _a : note.updateDate;
        if (!date)
            return undefined;
        var written = DateTime.fromJSDate(new Date(date));
        return written.hasSame(DateTime.local(), 'day') ? "".concat(t('today'), " ").concat(written.toFormat('HH:mm')) : dayOf(date);
    };
    var stayNoteSource = function (note) {
        var _a, _b;
        if (!note.start && !note.sectorName && !note.serviceName) {
            return [pmsName(note.provider), categoryOf(note.category)].filter(Boolean).join(' · ');
        }
        var by = note.guestChannel === 'GUEST_APP' ? t('Guest app')
            : note.guestChannel ? t('Booking engine')
                : note.provider ? pmsName(note.provider)
                    : writerOf(note.writer);
        return [by, (_b = (_a = note.serviceName) !== null && _a !== void 0 ? _a : note.sectorName) !== null && _b !== void 0 ? _b : t('Booking'), note.start && dayOf(note.start)].filter(Boolean).join(' · ');
    };
    var notes = (_b = profile.internalNotes) !== null && _b !== void 0 ? _b : [];
    var crqlarRows = notes
        .filter(function (note) { return hasText(note) && isWrittenInCrqlar(note) && !isBookingCopy(note); })
        .sort(function (a, b) { return timeOf(b) - timeOf(a); })
        .map(function (note) {
        var _a;
        return ({
            text: note.note.trim(),
            source: [(_a = writerOf(note.userEmailSource)) !== null && _a !== void 0 ? _a : 'Crqlar', writtenAt(note)].filter(Boolean).join(' · '),
            crqlarNote: note
        });
    });
    // Prefer Crqlar notes, then the first source for each duplicate text.
    var crqlarTexts = new Set(crqlarRows.map(function (row) { return row.text; }));
    var otherRows = __spreadArray(__spreadArray(__spreadArray([], (stayNotes !== null && stayNotes !== void 0 ? stayNotes : []).map(function (note) { return ({
        text: note.note.trim(),
        source: stayNoteSource(note),
        guestNote: note.guestChannel ? note : undefined
    }); }), true), notes
        .filter(function (note) { return hasText(note) && isBookingCopy(note); })
        .map(function (note) { return ({ text: note.note.trim(), source: t('Booking') }); }), true), notes
        .filter(function (note) { return hasText(note) && !isWrittenInCrqlar(note); })
        .map(function (note) {
        var _a, _b;
        return ({
            text: note.note.trim(),
            source: [pmsName((_b = (_a = note.externalInfo) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.provider), categoryOf(note.name)].filter(Boolean).join(' · ')
        });
    }), true).filter(function (row, position, all) { return !crqlarTexts.has(row.text) && all.findIndex(function (other) { return other.text === row.text; }) === position; });
    var rows = __spreadArray(__spreadArray([], crqlarRows, true), otherRows, true);
    var saveMut = useMutation(function (internalNotes) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ProfileService.updateProfile(__assign(__assign({}, profile), { internalNotes: internalNotes }))];
                case 1:
                    response = _a.sent();
                    setProfile(response);
                    return [2 /*return*/];
            }
        });
    }); });
    // The guest's note lives on their bookings: the API edits it there and answers the profile, as its copies change too.
    var guestNoteMut = useMutation(function (update) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = setProfile;
                    return [4 /*yield*/, ProfileService.updateGuestNote(profile.id, update)];
                case 1:
                    _a.apply(void 0, [_b.sent()]);
                    return [4 /*yield*/, queryClient.invalidateQueries(['stayNotes', profile.id])];
                case 2:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); });
    var add = function () {
        var text = draft.trim();
        if (!text)
            return;
        var now = new Date();
        saveMut.mutate(__spreadArray(__spreadArray([], notes, true), [{ note: text, noteType: 'Internal', guestViewable: false, userEmailSource: me === null || me === void 0 ? void 0 : me.email, insertDate: now, updateDate: now }], false), { onSuccess: function () { return setDraft(''); } });
    };
    var saveEdit = function () {
        var text = editing === null || editing === void 0 ? void 0 : editing.text.trim();
        if (!editing || !text)
            return;
        var _a = editing.row, crqlarNote = _a.crqlarNote, guestNote = _a.guestNote;
        var close = { onSuccess: function () { return setEditing(undefined); } };
        if (guestNote) {
            guestNoteMut.mutate({ note: guestNote.note, newNote: text }, close);
        }
        else if (crqlarNote) {
            saveMut.mutate(notes.map(function (note) { return isSameNote(note, crqlarNote) ? __assign(__assign({}, note), { note: text, updateDate: new Date() }) : note; }), close);
        }
    };
    var remove = function (removed) {
        saveMut.mutate(notes.filter(function (note) { return !isSameNote(note, removed); }), { onSuccess: function () { return setDeleting(undefined); } });
    };
    return (_jsx(CollapsibleSection, __assign({ title: t('Notes'), summary: rows.length ? String(rows.length) : undefined, defaultOpen: true, onOpen: function () { return setFocusDraft(true); } }, { children: _jsxs(Stack, __assign({ gap: 1.5 }, { children: [!readOnly && (_jsx(TextField, { value: draft, onChange: function (event) { return setDraft(event.target.value); }, onKeyDown: function (event) {
                        if (event.key === 'Enter' && !event.shiftKey) {
                            event.preventDefault();
                            add();
                        }
                    }, placeholder: t('Write a note…'), autoFocus: focusDraft, fullWidth: true, multiline: true, maxRows: 6, InputProps: {
                        sx: { alignItems: 'center', py: '6px', pr: '6px' },
                        endAdornment: (_jsx(LoadingButton, __assign({ variant: 'contained', onClick: add, loading: saveMut.isLoading && !editing && !deleting, sx: { alignSelf: 'flex-end', ml: 1, flexShrink: 0 } }, { children: t('Add') })))
                    } })), rows.length > 0 && (_jsx(Box, __assign({ sx: { border: '1px solid', borderColor: 'divider', borderRadius: '8px' } }, { children: rows.map(function (row, position) {
                        var edited = editing && isSameRow(row, editing.row) ? editing : undefined;
                        return (_jsxs(Stack, __assign({ direction: 'row', alignItems: 'flex-start', gap: 1, sx: { px: 2, py: 1.25, borderTop: position > 0 ? '1px solid' : 'none', borderColor: 'divider' } }, { children: [edited ? (_jsxs(Stack, __assign({ gap: 1, flex: 1 }, { children: [_jsx(TextField, { value: edited.text, onChange: function (event) { return setEditing(__assign(__assign({}, edited), { text: event.target.value })); }, autoFocus: true, fullWidth: true, multiline: true, minRows: 3, maxRows: 10, size: 'small', inputProps: { style: { fontSize: 16, lineHeight: 1.5 } } }), edited.row.guestNote && (_jsx(Alert, __assign({ severity: 'info' }, { children: t('The guest can see this note.') }))), _jsxs(Stack, __assign({ direction: 'row', justifyContent: 'flex-end', gap: 1 }, { children: [_jsx(Button, __assign({ onClick: function () { return setEditing(undefined); } }, { children: t('Cancel') })), _jsx(LoadingButton, __assign({ variant: 'contained', onClick: saveEdit, loading: saveMut.isLoading || guestNoteMut.isLoading, disabled: !edited.text.trim() }, { children: t('Save') }))] }))] }))) : (_jsxs(Box, __assign({ flex: 1, minWidth: 0 }, { children: [_jsx(Typography, __assign({ sx: { fontSize: 16, lineHeight: 1.5, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' } }, { children: row.text })), _jsx(Typography, __assign({ variant: 'body2', color: 'text.secondary', mt: 0.25 }, { children: row.source }))] }))), _jsx(Box, __assign({ sx: { width: 36, height: 24, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' } }, { children: (row.crqlarNote || row.guestNote) && !readOnly && !edited && (_jsx(IconButton, __assign({ "aria-label": t('Note actions'), onClick: function (event) { return setMenu({ anchorEl: event.currentTarget, row: row }); }, sx: { width: 36, height: 36, flexShrink: 0, color: 'text.secondary' } }, { children: _jsx(MoreVertIcon, { sx: { fontSize: 20 } }) }))) }))] }), position));
                    }) }))), rows.length === 0 && readOnly && (_jsx(Typography, __assign({ color: 'text.secondary' }, { children: t('No notes available for this guest') }))), _jsxs(Menu, __assign({ anchorEl: menu === null || menu === void 0 ? void 0 : menu.anchorEl, open: !!menu, onClose: function () { return setMenu(undefined); } }, { children: [_jsxs(MenuItem, __assign({ onClick: function () {
                                if (menu)
                                    setEditing({ row: menu.row, text: menu.row.text });
                                setMenu(undefined);
                            } }, { children: [_jsx(ListItemIcon, { children: _jsx(EditOutlinedIcon, { fontSize: 'small' }) }), _jsx(ListItemText, { children: t('Edit') })] })), (menu === null || menu === void 0 ? void 0 : menu.row.crqlarNote) && (_jsxs(MenuItem, __assign({ onClick: function () {
                                setDeleting(menu === null || menu === void 0 ? void 0 : menu.row.crqlarNote);
                                setMenu(undefined);
                            }, sx: { color: 'error.main' } }, { children: [_jsx(ListItemIcon, __assign({ sx: { color: 'error.main' } }, { children: _jsx(DeleteOutlineIcon, { fontSize: 'small' }) })), _jsx(ListItemText, { children: t('Delete') })] })))] })), _jsx(CommonConfirmDialog, { open: !!deleting, onClose: function () { return setDeleting(undefined); }, onConfirm: function () { return deleting && remove(deleting); }, title: t('Delete this note?'), message: deleting === null || deleting === void 0 ? void 0 : deleting.note, confirmLabel: t('Delete') })] })) })));
};
export default GuestNotes;
